import tenDLCServices from 'services/tenDLCServices';

export const tenDLCActions = {
  getListBrand: 'getListBrand',
};

export default {
  [tenDLCActions.getListBrand]: {
    saga: function*({ payload = {} }) {
      const { callbacks, filters = {} } = payload;
      try {
        const response = yield tenDLCServices.brand.getListBrand(filters);
        callbacks && callbacks.onSuccess(response);
      } catch (error) {
        callbacks && callbacks.onFailed(error);
      }
    },
  },
};
